import { Injectable } from '@angular/core';

import { Resolve } from '@angular/router';
import {Observable} from 'rxjs';
import {User} from '../User';
import {ApiService} from '../api/api.service';

@Injectable()
export class UserResolver implements Resolve<Observable<User>> {

  constructor(private api: ApiService) {}

  resolve() {
    return this.api.getUser();
  }
}
